export const CARE_QUEUE_ANALYTICS_EVENT = 'CARE_QUEUE_ANALYTICS';

export type CareQueueAnalyticsPayload = Record<string, unknown>;

export interface CareQueueAnalyticsDetail {
  eventName: string;
  payload: CareQueueAnalyticsPayload;
}

export function trackCareQueueEvent(
  eventName: string,
  payload: CareQueueAnalyticsPayload = {},
): void {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(
      new CustomEvent<CareQueueAnalyticsDetail>(CARE_QUEUE_ANALYTICS_EVENT, {
        detail: { eventName, payload },
      }),
    );
  } catch {
    // Analytics must never crash the widget.
  }
}

export function bucketLength(charCount: number): 'short' | 'medium' | 'long' {
  if (charCount < 50) return 'short';
  if (charCount < 200) return 'medium';
  return 'long';
}
